import type {
	CreateReimbursmentRequest,
	ReimbursmentRequest,
} from "@ied/shared-types";
import { useMutation } from "@tanstack/react-query";
import { SERVICE_API } from "@/lib/consts";

export function useCreateReimbursementRequest() {
	return useMutation({
		mutationKey: ["reimbursements"],
		mutationFn: async (
			request:
				| (Omit<CreateReimbursmentRequest, "id"> & { documents?: File[] })
				| FormData,
		) => {
			const res = await fetch(`${SERVICE_API}/api/reimbursements`, {
				method: "POST",
				credentials: "include",
				// Don't set Content-Type for FormData - browser sets it with boundary
				...(!(request instanceof FormData) && {
					headers: {
						"Content-Type": "application/json",
					},
				}),
				body: request instanceof FormData ? request : JSON.stringify(request),
			});
			if (!res.ok) {
				throw new Error("Unable to create reimbursement request");
			}
			return (await res.json()) as ReimbursmentRequest;
		},
	});
}
